<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->

<template>
	<div class="container">Forms and Documents</div>
</template>
<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import IdMixin from '@/mixins/id';

@Component({
	name: 'FormsDocuments',
	components: {},
	props: {
		automationId: {
			type: String,
			required: true
		}
	},
	mixins: [IdMixin]
})
export default class UserPreference extends Vue {}
</script>
<style lang="scss" @scoped>
.container > div {
	margin-bottom: 1%;
	margin-left: 0;
	margin-right: 0;
}
</style>
<!-- *************************************************************************
	TRANSLATIONS
	************************************************************************* -->

<i18n>
{
	"en": {
		
	},
	"fr": {

	}
}
</i18n>
